module.exports = __webpack_public_path__ + "static/media/exc_saf_sta.171864af.png";